/**
 * API URLS
 */
export const urls = {
  login: '/auth/api/login',
  register: '/auth/api/register',
  adminLogin: '/auth/api/admin/login',
  resetPassword: '/auth/api/reset-password',
  sendOtp: '/auth/api/send-otp',
  verifyOtp: '/auth/api/verify-otp',
  sendPasswordLink: '/auth/api/forgate-password-link',
  createStaffPassword: '/auth/api/staff/create-password',

  // User api
  createApplication: '/api/application',
  newApplication:'/api/application/add-tenant',
  getApplications: '/api/applications',
  updateTenant: '/api/application/update-tenant',
  deleteTenant: '/api/application/delete-tenant',
  uploadApplicationDocument: '/api/application/document',
  deleteDocuments: '/api/application/document/delete',
  getApplicationById: '/api/application_by_id',
  updateApplicantProfile: '/api/user/profile',
  getCityList: '/api/user/city-admin',
  searchAddress: '/api/city/address',
  createPaymentIntent: '/api/application/payment',
  feeDetails:`/api/application/fee`,
  submitted:`/api/application/submitted`,
  Resubmit:`/api/application/re-submite`,
  RessubmitApp:`/api/application/re-submitted`,
  applicationPayment: '/api/application/payment',
  addACHAccount: '/api/ach-account',
  verifyACHAccount: '/api/ach-account/verify',
  verifyCreditCard: '/api/ach-account/card/verify',
  deleteACHAccount: '/api/ach-account/delete',
  getACHAccount: '/api/ach-account',
  achAccountList: '/api/ach-account',
  achAccountListIndex: "/api/ach-account-index",
  getUserApplicationDetail: "/api/application/tenant",
  deleteTenantUnit: '/api/application/delete-tenant-unit',
  updateTenantUnit: '/api/application/update-tenant-unit',

  // Admin Api
  addCityAdmin: '/api/admin/city-admin/create',
  getCityAdminList: '/api/admin/city-admin',
  updateCityAdmin: '/api/admin/city-admin/update',
  addStaff: '/api/admin/staff',
  getAdminStaff: '/api/admin/staff',
  resendStaffLink: '/api/admin/staff/resend-password-link',
  saveAddress: '/api/admin/upload/address',
  getAdminApplication: '/api/admin/applications',
  adminApplicationById: '/api/admin/application_by_id',
  postSubmissionReview: '/api/admin/clerk-submission-review',
  voidSubmissionReview: '/api/admin/application/clerk/submission/void',
  postDecision: '/api/admin/board-decision',
  voidDecision: '/api/admin/board-decision/void',
  submitNotes: '/api/admin/application_notes',
  postEmail: '/api/admin/application_email',
  deleteNote: '/api/admin/application_notes/void',
  postPayment: '/api/admin/application_fee',
  voidPayment: '/api/admin/application_fee/void',
  adminUpdateApplicantProfile: '/api/admin/update-applicant-details',
  adminDeleteTenant: '/api/admin/application/delete-tenant',
  adminUploadDocument: '/api/admin/application/document',
  adminUpdateTenant: '/api/admin/update-tenant',
  adminDeleteDocument: '/api/admin/application/document/delete',
  imageBaseUrl: '/uploads/',
  waiveOffFee:`/api/admin/waveoff/initial_fee`,
  updateTenantUnitadmin: '/api/admin/application/update-tenant-unit',
  deleteTenantUnitadmin: '/api/admin/application/delete-tenant-unit',
  getTenants:'/api/admin//application/tenant'

}
